module.exports = __webpack_public_path__ + "static/media/VU.0a962a79.svg";